import CrudCustom from '../../../libs/custom/CrudCustom';

let TipePegawaiService = new CrudCustom('/tipe-pegawais');
export default TipePegawaiService;
